<!-- eslint-disable -->
<template>
	<div>
		<div v-for="(item, index) in parseData" :key="index" class="d-flex">
			<div>
				<img
					src="@/assets/icons/history-track.svg"
					class="mr-2"
					style="position:relative;"
					alt="track"
				/>
				<div class="track-line" :style="index === data.length - 1 ? 'border-left:none;' : ''" />
			</div>
			<div class="d-flex flex-column w-100">
				<div class="d-flex justify-content-between text-gotham-bold text-12">
					<div class="text-gotham align-self-center">
						{{ getStatusDisplayName(item.status, is_stop_without_scan).text }}
					</div>
					<div class="align-self-center" style="color:#929293;">
						{{ epochToDateTimeLocalFormat(item.createdAt) || "-" }}
					</div>
				</div>
				<hr class="w-100" />
			</div>
		</div>
	</div>
</template>

<script>
/* eslint-disable */

export default {
	props: {
		/**
		 * data is an array of object, with object have a field
		 * text: 'test',
		 * date: 'test',
		 * textStyle: String,
		 * dateStyle: String
		 */
		data: Array,
		is_stop_without_scan: Boolean,
	},
	computed: {
		parseData() {
			if(this.data){
				return [...this.data].reverse() || [];
			}else{
				return [];
			}
		},
	},
	methods: {},
};
</script>

<style scoped>
.track-line {
	border-left: thin solid #56c378;
	height: 100%;
	transform: translate(25%, -5px);
}

img {
	vertical-align: baseline;
}
</style>
